(function () {
  'use strict';

  let angular = window.angular;

  EdgeAgentFormController.$inject = [
    '$rootScope',
    '$scope',
    '$element',
    '$timeout',
    'AppUtils',
    'EdgeAgentTemplate',
    'EdgeAgentService',
    'AssetWizardTypeService',
  ];

  angular.module('app').component('deviceEdgeAgentForm', {
    template:'<form name="ctrl.edgeAgentForm" class="form-full validate"><div class="form-group marginB20" show-errors><label for="edgeAgentName"><span translate>entities._all.name</span> <span class="text-danger">*</span></label> <input id="edgeAgentName" name="edgeAgentName" translate-attr="{placeholder: \'entities._all.name\'}" class="form-control input-sm" required ng-model="ctrl.edgeAgent.name" ng-model-options="{ debounce: 200 }" ng-change="ctrl.isTaken(ctrl.edgeAgent.name, ctrl.names, ctrl.edgeAgentForm.edgeAgentName)" ng-pattern="ctrl.nameRegex"><div class="help-block" ng-messages="ctrl.edgeAgentForm.edgeAgentName.$error"><div ng-messages-include="messages.html"></div></div></div><div ng-hide="true" class="row"><div class="col-md-7"><label for="edgeAgentImage"><span translate>entities._all.image</span> <span class="text-danger">*</span></label><div class="row"><div class="col-sm-8"><div class="form-group marginB20" show-errors><input id="edgeAgentImage" name="edgeAgentImage" translate-attr="{placeholder: \'entities.edgeagent.image\'}" class="form-control input-sm" required ng-model="ctrl.edgeAgent.image.name"><div class="help-block" ng-messages="ctrl.edgeAgentForm.edgeAgentImage.$error"><div ng-messages-include="messages.html"></div></div></div></div><div class="col-sm-4"><div class="form-group marginB20" show-errors><input id="edgeAgentImageVersion" name="edgeAgentImageVersion" ng-model="ctrl.edgeAgent.image.version" translate-attr="{placeholder: \'entities.edgeagent.imageVersion\'}" class="form-control input-sm" required><div class="help-block" ng-messages="ctrl.edgeAgentForm.edgeAgentImageVersion.$error"><div ng-messages-include="messages.html"></div></div></div></div></div></div><div class="col-md-5"><div class="form-group marginB20" show-errors><label for="edgeAgentSharedPath"><span translate>entities.edgeagent.sharedFolder</span> <span class="text-danger">*</span></label> <input id="edgeAgentSharedPath" name="edgeAgentSharedPath" translate-attr="{placeholder: \'entities.edgeagent.sharedFolder\'}" class="form-control input-sm" required ng-model="ctrl.edgeAgent.sharedPath"><div class="help-block" ng-messages="ctrl.edgeAgentForm.edgeAgentSharedPath.$error"><div ng-messages-include="messages.html"></div></div></div></div></div><div class="checkbox marginT0 marginB20"><label><input type="checkbox" ng-model="ctrl.edgeAgent.enabled"> <span translate>entities._all.enabled</span></label></div><div ng-if="!ctrl.disableTemplateSelection"><div class="form-group" show-errors><label translate><span translate>entities.edgeagenttemplate.modelName</span></label> <input type="hidden" class="form-control" name="agentTemplateId" ng-model="ctrl.agentTemplateId"><ui-select ng-model="ctrl.agentTemplateId" ng-change="ctrl.onLoadEdgeAgentTemplateTagsSelect()" ng-disabled="ctrl.loadingTemplates" theme="select2"><ui-select-match placeholder="{{::\'general._select.fa\' | translate}} {{::\'entities.edgeagenttemplate.modelName\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="template.id as template in ctrl.templates | filter: $select.search">{{template.name}}</ui-select-choices></ui-select><div class="help-block" ng-messages="ctrl.generalForm.agentTemplate.$error"><div ng-messages-include="messages.html"></div></div></div><div class="form-group" show-errors ng-if="ctrl.agentTemplateId"><label><div><span translate>entities.edgeagenttemplate.tag.modelName</span> <span class="text-danger">*</span></div></label> <input id="templateVersion" type="hidden" class="form-control" name="templateVersion" ng-model="ctrl.edgeAgent.templateTagId" required><ui-select ng-model="ctrl.edgeAgent.templateTagId" ng-disabled="ctrl.loadingTemplates || ctrl.loadingVersions || !ctrl.agentTemplateId" theme="select2"><ui-select-match placeholder="{{::\'general._select.fa\' | translate}} {{::\'entities.edgeagenttemplate.tag.modelName\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="tag._id as tag in ctrl.templateTags | orderBy: \'-created\' | filter: $select.search">{{tag.name}}</ui-select-choices></ui-select><div class="help-block" ng-messages="ctrl.generalForm.templateVersion.$error"><div ng-messages-include="messages.html"></div></div><div class="help-block" ng-messages="ctrl.edgeAgentForm.templateVersion.$error"><div ng-messages-include="messages.html"></div></div></div></div></form>',
    controller: EdgeAgentFormController,
    controllerAs: 'ctrl',
    bindings: {
      edgeAgent: '<',
      names: '<',
      assets: '<?',
      templateTags: '=?',
      disableTemplateSelection: '<',
    },
  });

  function EdgeAgentFormController(
    $root,
    $scope,
    $element,
    $timeout,
    utils,
    EdgeAgentTemplate,
    EdgeAgentService,
    AssetWizardTypeService
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      if (vm.edgeAgent.image) {
        const split = vm.edgeAgent.image.split(':');
        vm.edgeAgent.image = {
          name: split[0],
          version: split[1],
        };
      }
      vm.edgeAgent.image = vm.edgeAgent.image || { name: '.', version: '.' };
      vm.edgeAgent.sharedPath = vm.edgeAgent.sharedPath || '.';
      vm.edgeAgent.enabled =
        typeof vm.edgeAgent.enabled === 'boolean' ? vm.edgeAgent.enabled : true;

      vm.isTaken = isTaken;
      vm.nameRegex = /^[A-Za-z0-9]+[A-Za-z0-9_.\-]*$/;

      $scope.$on('ds:agent-validate', function () {
        $scope.$emit('ds:agent-validate-after', validate());
      });

      if (!vm.disableTemplateSelection) {
        loadEdgeAgentTemplates().then(() => {
          if (vm.edgeAgent.templateId) {
            vm.agentTemplateId = vm.edgeAgent.templateId;
          }
          loadEdgeAgentTemplateTags();
        });
      }

      vm.onLoadEdgeAgentTemplateTagsSelect = onLoadEdgeAgentTemplateTagsSelect;
    };

    function isTaken(property, taken, formProperty) {
      let isTaken = Array.isArray(taken) && taken.indexOf(property) !== -1;
      formProperty.$setValidity('taken', !isTaken);
    }

    function validate() {
      $scope.$broadcast('show-errors-check-validity');
      if (vm.edgeAgentForm.edgeAgentName) {
        isTaken(vm.edgeAgent.name, vm.names, vm.edgeAgentForm.edgeAgentName);
      }

      return {
        valid: vm.edgeAgentForm.$valid && !vm.loadingTemplates && !vm.loadingVersions,
      };
    }

    function loadEdgeAgentTemplates() {
      vm.loadingTemplates = true;
      return EdgeAgentTemplate.v2Find()
        .$promise.then((templates) => {
          vm.templates = templates;
          vm.templateTags = [];
          vm.loadingTemplates = false;
        })
        .catch((err) => {
          vm.templates = [];
          vm.templateTags = [];
          vm.loadingTemplates = false;
          err = utils.getHTTPError(err);
          console.log(err);
        });
    }

    function onLoadEdgeAgentTemplateTagsSelect() {
      if (vm.edgeAgent.templateTagId) {
        vm.edgeAgent.templateTagId = undefined;
      }
      loadEdgeAgentTemplateTags();
    }

    function loadEdgeAgentTemplateTags() {
      if (!vm.agentTemplateId) {
        vm.templateTags = [];
        return;
      }

      vm.loadingVersions = true;
      return EdgeAgentTemplate.v2GetTemplateTags({
        id: vm.agentTemplateId,
      })
        .$promise.then((tags) => {
          for (let tag of tags) {
            tag._id = vm.agentTemplateId + '/' + tag.id;
          }

          vm.templateTags = tags;
          vm.loadingVersions = false;
        })
        .catch((err) => {
          vm.templateTags = null;
          vm.loadingVersions = false;
          err = utils.getHTTPError(err);
          console.log(err);
        });
    }
  }
})();
